<div class="product-card">
  <div class="product-card-image-wrapper i-width-100 d-flex align-items-center mb-2">
    <img [src]="getProductImageUrl(productCard.imageUrls[0])" class="product-card-image" alt="card image">
  </div>
  <div class="product-name mb-1">{{ productCard.productName }}</div>
  <p class="product-price mb-3">${{ totalPriceUSD | number:'1.1-1' }}{{ ' / ' + totalPriceAMD + ' ' }}<span
    style="font-size:14px!important;">{{ ('subscription_plan_content.AMD' | translate) }}</span></p>
  <div class="d-flex justify-content-center mb-3 cursor-pointer">
    @if (productCard.attributeValues.length > 0) {
      @for (attribute of productCard.attributeValues; track attribute) {
        <div class="color-box mx-2" [style.background-color]="attribute.value"
             [class.selected]="selectedColor === attribute.id"
             (click)="selectColor(attribute)">
        </div>
      }
    }
  </div>
  <div class="quantity-selector">
    <button (click)="decreaseQuantity()" [disabled]="quantity <= 1">&minus;</button>
    <span>{{ quantity }}</span>
    <button (click)="increaseQuantity()">&plus;</button>
  </div>
  <button class="filled-button tall-button mobile-button"
          (click)="isMobile() ? redirectToProductDetailsPage() : openProductDetailsDialog()">{{ 'products_content.learn_more' | translate }}
  </button>
  <div class="mt-2 flex-direction-row align-items-center"
       [class]="(productCard.isAddedToCart || showAddedCheck) ? 'justify-content-between' : ''">
    <button class="text-button tall-button mobile-button add-to-card" [class]="(productCard.isAddedToCart || showAddedCheck) ? 'width-80' : ''"
            (click)="addToCart()">
      {{ 'products_content.add_to_cart' | translate }}
    </button>
    @if (showAddedCheck) {
      <img class="selected-card-icon" src="assets/svg/selected.svg" alt="added">
    } @else if (productCard.isAddedToCart) {
      <button class="cart-link-button" type="button" title="Go to Cart" aria-label="Go to Cart"
              (click)="goToCart()">
        <img class="cart-link-icon" src="assets/shipping-address/shoppingCardwhite.svg" alt="cart">
      </button>
    }
  </div>
</div>
